import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({ providedIn: 'root' })
export class ActionMenuService {
  private readonly _opened = new Subject<symbol>();
  readonly opened$ = this._opened.asObservable();

  notifyOpen(sourceId: symbol): void {
    this._opened.next(sourceId);
  }
}